import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';

import { IS_POLLING_REQUEST } from './polling.context';

/** Adds Session-Refresh: 0 so polling requests do not extend the session. */
export function pollingInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (!request.context.get(IS_POLLING_REQUEST)) {
    return next(request);
  }

  return next(
    request.clone({
      setHeaders: {
        'Session-Refresh': '0',
      },
    }),
  );
}
